export const COPY_VIDEO_CONFIRM_TEXT = `Please select a playlist to insert this video into`;